/**
* @file 运营中心-公司钱包
* */
<template>
  <div id="organizationFlowing">
    <custom-table :labelWidth="140" ref="customTable" :customOptions="customOptions" :columns="columns"
                  has-organization="true" excel-type="InspectStatistics"
    >
      <template slot-scope="{item, row}">
        <template v-if="item.prop === 'created'">{{ row.created | filterTime }}</template>
        <template v-else-if="item.prop === 'licenseNo'">
          <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)">{{ formatPlateNumber(row.licenseNo) }}</span>
          <span v-else>-</span>
        </template>
        <div v-else-if="item.prop == 'inspectFee'">
          <span v-if="row.inspectFee" style="color: #ff9900"> ¥{{ row.inspectFee }}</span>
          <span v-else>-</span>
        </div>
        <template v-else>{{ row[item.prop] ? row[item.prop] : '-' }}</template>
      </template>
    </custom-table>
  </div>
</template>

<script>
export default {
  name: "organizationFlowing",
  data() {
    return {
      // 配置项
      customOptions: {
        // 请求的列表url
        url: '/api/v1/manage/inspect/statistics',
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20 // 每页条数
        },
        search: [
          {
            type: 'daytime',
            field: 'Time',
            name: '统计时间',
            clearable:false,
            value: [new Date().setHours(0, 0, 0, 0), new Date().setHours(0, 0, 0, 0)]
          },
          { type: "input", field: "licenseNo", name: "车辆号牌", value: "" },
          { type: "input", field: "vehicleCompanyName", name: "车辆所属", value: "" },
        ]
      },
      // 表头
      columns: [
        // {prop: 'inspectorName', label: '安检员'},
        {prop: 'licenseNo', label: '车辆号牌'},
        {prop: 'vehicleNo', label: '车辆编号'},
        {prop: 'vehicleCompanyName', label: '车辆所属'},
        {prop: 'inspectNum', label: '安检次数'},
        {prop: 'inspectFee', label: '安检金额'},
      ],
      flowing: ''
    }
  },
  async created() {

  },
  methods: {

    /**
     * 状态改变
     */
    statusChange() {
      this.customOptions.params.page = 1
      this.$refs.customTable.listFn();
    }
  }
}
</script>

<style scoped>

</style>
